import { render, staticRenderFns } from "./oditem.vue?vue&type=template&id=cd93ee30&scoped=true&"
import script from "./oditem.vue?vue&type=script&lang=js&"
export * from "./oditem.vue?vue&type=script&lang=js&"
import style0 from "./oditem.vue?vue&type=style&index=0&id=cd93ee30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd93ee30",
  null
  
)

export default component.exports